import React from 'react';
import styled, { css } from 'styled-components';
import { theme, toRem } from 'design';
import { Icon } from '../Icon';

interface IHeaderMenuButtonProps {
  isNavOpen?: boolean;
  onClick?: () => void;
  isHidden?: boolean;
}

const Layout = styled.div<{ isHidden?: boolean }>`
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  width: ${toRem(theme.header.height)};
  height: 100%;

  ${({ isHidden }) =>
    isHidden &&
    css`
      visibility: hidden;
      width: ${toRem(24)};
    `}
`;

const Button = styled.button<IHeaderMenuButtonProps>`
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  width: ${toRem(44)};
  height: ${toRem(44)};
  border-radius: ${toRem(11)};
  background-color: transparent;
  transition: background-color ${theme.transition.button.default};

  svg {
    fill: ${theme.color.white};
    transition: fill ${theme.transition.icon};
  }

  &:hover {
    background-color: rgba(255, 255, 255, 0.055);

    svg {
      fill: ${theme.color.white};
    }
  }

  ${({ isNavOpen: menuOpen }) =>
    menuOpen &&
    css`
      background-color: rgba(255, 255, 255, 0.055);

      @media (min-width: ${theme.breakpoint.small}px) {
        background-color: transparent;
      }
    `}
`;

const HeaderMenuButton: React.FC<IHeaderMenuButtonProps> = ({ isNavOpen, onClick, isHidden }: IHeaderMenuButtonProps) => (
  <Layout onClick={onClick} isHidden={isHidden}>
    <Button isNavOpen={isNavOpen}>
      <Icon icon="Menu" width={20} height={20} />
    </Button>
  </Layout>
);

export default HeaderMenuButton;
